import { render, staticRenderFns } from "./schoolData.vue?vue&type=template&id=0c10a951&scoped=true&"
import script from "./schoolData.vue?vue&type=script&lang=js&"
export * from "./schoolData.vue?vue&type=script&lang=js&"
import style0 from "./schoolData.vue?vue&type=style&index=0&id=0c10a951&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c10a951",
  null
  
)

export default component.exports